import React, { useEffect } from "react";

const Monitor = () => {
    return(
        <div>
            <p>Hola mundo</p>
        </div>
    )
};
export default Monitor;